import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "bg-blue-grey-lighten-5 text-primary" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('chat.absenceModal.title')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_form, { ref: "post_absence_form" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, { class: "py-3" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_menu, {
                modelValue: _ctx.isDatePicker,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isDatePicker) = $event)),
                "close-on-content-click": false,
                transition: "scale-transition",
                "disable-resize": true,
                "min-width": "auto"
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_text_field, _mergeProps({
                    modelValue: _ctx.dateRangeText,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateRangeText) = $event)),
                    label: _ctx.t('chat.absenceModal.fields.period'),
                    "prepend-icon": "mdi-calendar",
                    rules: [_ctx.rules.required],
                    variant: "outlined",
                    density: "compact",
                    readonly: ""
                  }, props), null, 16, ["modelValue", "label", "rules"])
                ]),
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_component_v_date_picker, {
                    modelValue: _ctx.dates,
                    "onUpdate:modelValue": [
                      _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dates) = $event)),
                      _ctx.handleDateUpdate
                    ],
                    "hide-header": "",
                    locale: _ctx.datePickerLocale,
                    key: `absence-picker-${_ctx.datePickerLocale}`,
                    min: _ctx.allowMinDate,
                    multiple: "range",
                    "view-mode": "month"
                  }, {
                    actions: _withCtx(() => [
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_btn, {
                        variant: "text",
                        color: "primary",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDatePicker = false))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('chat.absenceModal.actions.ok')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "locale", "min", "onUpdate:modelValue"]))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "mt-4" }, null, -1)),
              _createVNode(_component_v_select, {
                modelValue: _ctx.selectedReason,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedReason) = $event)),
                items: _ctx.reasonOptions,
                "item-title": "title",
                "item-value": "value",
                rules: [_ctx.rules.required],
                label: _ctx.t('chat.absenceModal.fields.reason'),
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue", "items", "rules", "label"]),
              (_ctx.selectedReason === 'infection')
                ? (_openBlock(), _createBlock(_component_v_select, {
                    key: 0,
                    modelValue: _ctx.infection,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.infection) = $event)),
                    items: _ctx.infectionOptions,
                    "item-title": "title",
                    "item-value": "value",
                    rules: [_ctx.rules.required],
                    label: _ctx.t('chat.absenceModal.fields.detail'),
                    variant: "outlined",
                    class: "infection-select",
                    "menu-props": { 
            contentClass: 'infection-select-menu',
          },
                    density: "compact"
                  }, null, 8, ["modelValue", "items", "rules", "label"]))
                : _createCommentVNode("", true),
              (_ctx.selectedReason === 'others')
                ? (_openBlock(), _createBlock(_component_v_textarea, {
                    key: 1,
                    modelValue: _ctx.comment,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.comment) = $event)),
                    rules: [_ctx.rules.required, _ctx.rules.counter500],
                    label: _ctx.t('chat.absenceModal.fields.comment'),
                    variant: "outlined",
                    density: "compact"
                  }, null, 8, ["modelValue", "rules", "label"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _cache[8] || (_cache[8] = _createElementVNode("div", { style: {"width":"20px"} }, null, -1)),
              _createVNode(_component_v_btn, {
                onClick: _ctx.close,
                color: "error",
                variant: "text"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('common.cancel')), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _cache[9] || (_cache[9] = _createElementVNode("div", { style: {"width":"20px"} }, null, -1)),
              _createVNode(_component_v_btn, {
                onClick: _ctx.clickPost,
                loading: _ctx.btnLoading,
                color: "primary",
                variant: "flat"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('common.submit')), 1)
                ]),
                _: 1
              }, 8, ["onClick", "loading"]),
              _createVNode(_component_v_spacer)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }))
}